import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { IonRow } from '@ionic/react';
import { RootState } from '../../models/RootState';
import withdrawal from '../../assets/images/common/icons/withdrawal.png';
import gpay from '../../assets/images/common/icons/gpay.svg';
import paytm from '../../assets/images/common/icons/paytm.svg';
import phonepay from '../../assets/images/common/icons/phonepay.svg';
import bank from '../../assets/images/common/icons/bank.svg';
import TabPanel from '../../components/TabPanel/TabPanel';
import { Tabs, Tab, Button, TextField, Dialog } from '@material-ui/core';
import './Payment.scss';
import './Withdraw.scss';
import FEATURE_API from '../../api-services/feature-api';
import NumberFormat from 'react-number-format';
import Spinner from '../../components/Spinner/Spinner';
import { toast } from 'react-toastify';
import SuccessIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import { setOpenWithdrawModal } from '../../store';
import { AccountDetails } from './AccountDetails';
import Add from '@material-ui/icons/Add';
import { isMobile } from 'react-device-detect';
import { useHistory } from 'react-router';
import { IonSpinner } from '@ionic/react';
import { DeleteForeverOutlined } from '@material-ui/icons';
import AGPAY_API from '../../api-services/feature-api';
import { Redirect } from 'react-router-dom';
import upiImg from '../../assets/images/common/icons/UPI.svg';
import ZenpayCrypto from './WithdrawTabPanels/ZenpayCrypto';

type StoreProps = {
  setOpenWithdrawModal: Function;
  langData:any;
};

const Withdrawal: React.FC<StoreProps> = (props) => {
  const { setOpenWithdrawModal,langData } = props;
  const [tabValue, setTabValue] = useState<number>(0);
  const [showBankOptions, setShowBankOptions] = useState<boolean>(false);
  const [paymentOption, setPaymentOption] = useState<string>('NEFT');
  const [UpiOption, setUpiOption] = useState<string>('');
  const [onlinePaymentOption, setOnlinePaymentOption] = useState<string>('');
  const [accountDetails, setAccountDetails] = useState<AccountDetails[]>();
  const [selectedAccountId, setSelectedAccountId] = useState<string>();
  const [loading, setLoading] = useState<boolean>(false);
  const [addAccount, setAddAccount] = useState<boolean>(false);
  const [accountNumber, setAccountNumber] = useState<string>();
  const [withdrawAmount, setWithdrawAmount] = useState<string>();
  const [holderName, setHolderName] = useState<string>();
  const [displayName, setDisplayName] = useState<string>();
  const [ifscCode, setIfscCode] = useState<string>();
  const [upiId, setUPIId] = useState<string>();
  const [bankName, setBankName] = useState<string>();
  const [branchName, setBranchName] = useState<string>();
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [deleteId, setDeleteId] = useState<number>();
  const [providersList, setProvidersList] = useState([]);

  const history = useHistory();

  const [withdrawNotes, setWithdrawNotes] = useState<string>();

  const getPaymentProviders = async () => {
    setLoading(true);
    const accountId = sessionStorage.getItem('aid');
    try {
      const response = await AGPAY_API.get(
        `/agpay/v2/payment-settings/accounts/${accountId}`,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
            'Content-Type': 'application/json',
          },
        }
      );
      if (response.status === 200) {
        setProvidersList(response?.data?.withdraw_provider_list);
      }
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    getPaymentProviders();
  }, []);

  useEffect(() => {
    if (providersList?.length === 1) {
      if (providersList[0] === 'ZENPAY') setTabValue(0);
      else if (providersList[0] === 'PGMAN') setTabValue(1);
      else if (providersList[0] === 'SHARKPE') setTabValue(2);
      else if (providersList[0] === 'TRUSTLYPAY') setTabValue(3);
    }
  }, [providersList]);

  const fetchPaymentMethod = async () => {
    try {
      let params = { admin: false };
      if (providersList[0] !== 'TRUSTLYPAY') {
        params['paymentOption'] =
          paymentOption === 'GPAY' || paymentOption === 'PHONEPE'
            ? 'UPI'
            : paymentOption === 'CRYPTO_WALLET_TRANSFER' ? 'CRYPTO_WALLET'
              : paymentOption;
      }
      const response = await FEATURE_API.get(
        `/agpay/v2/pgman/payment-methods`,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
          params: params,
        }
      );
      if (response.status === 200) {
        setAccountDetails(response?.data);
      } else {
      }
    } catch (error) {}
  };

  const submitOnlinePayment = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        amount: Number(withdrawAmount),
        gatewayProvider: 'INSTAPETECH',
        notes: withdrawNotes,
        payment_method_id: selectedAccountId,
        payment_option: onlinePaymentOption,
        // paymentMethod: accountDetails[0].paymentMethod,
      };
      setLoading(true);
      const response = await FEATURE_API.post(
        `/agpay/v1/online/:payout`,
        payload,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        }
      );
      if (response.status === 204) {
        toast.success(
          <div>
            <SuccessIcon /> {langData?.['txn_saved_success_txt']}
          </div>,
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
      } else {
        toast.error(
          <div>
            <ErrorIcon /> {langData?.['general_err_txt']}
          </div>,
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
      }
      setLoading(false);
    } catch (error) {
      toast.error(
        <div>
          <ErrorIcon /> {error?.response?.data?.message}
        </div>,
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );

      setLoading(false);
    }
  };


  const submitZenPayment = async (e) => {
    e.preventDefault();
    if (Number(withdrawAmount) < 100) {
      toast.error(
        <div>
          <ErrorIcon /> {langData?.['min_100_withdrawal_amount_txt']}
        </div>,
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      return false;
    }
    setLoading(true);
    try {
      const payload = {
        amount: withdrawAmount,
        notes: withdrawNotes,
        payment_method_id: selectedAccountId,
        payment_method: 'BANK_TRANSFER',
        currency_type: 'INR',
        mobile_number: '9000900099',
      };
      const response = await FEATURE_API.post(
        `/agpay/v2/zenpay/transactions/:withdraw`,
        payload,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        }
      );
      if (response.status === 200) {
        toast.success(
          <div>
            <SuccessIcon /> {langData?.['txn_saved_success_txt']}
          </div>,
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
        setOpenWithdrawModal(false);
        history.push('/my_transactions');
      } else {
        toast.error(
          <div>
            <ErrorIcon /> {langData?.['general_err_txt']}
          </div>,
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
      }
      setLoading(false);
    } catch (error) {
      toast.error(
        <div>
          <ErrorIcon /> {error?.response?.data?.message}
        </div>,
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      setLoading(false);
    }
  };

  const submitPayment = async (e) => {
    e.preventDefault();
    if (Number(withdrawAmount) < 100) {
      toast.error(
        <div>
          <ErrorIcon /> {langData?.['min_100_withdrawal_amount_txt']}
        </div>,
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      return false;
    }
    setLoading(true);
    try {
      const payload = {
        amount: withdrawAmount,
        notes: withdrawNotes,
        payment_method_id: selectedAccountId,
        // paymentMethod: accountDetails[0].paymentMethod,
      };
      const response = await FEATURE_API.post(
        `/agpay/v2/pgman/transactions/:withdraw`,
        payload,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        }
      );
      if (response.status === 204) {
        toast.success(
          <div>
            <SuccessIcon /> {langData?.['txn_saved_success_txt']}
          </div>,
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
        setOpenWithdrawModal(false);
        history.push('/my_transactions');
      } else {
        toast.error(
          <div>
            <ErrorIcon /> {langData?.['general_err_txt']}
          </div>,
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
      }
      setLoading(false);
    } catch (error) {
      toast.error(
        <div>
          <ErrorIcon /> {error?.response?.data?.message}
        </div>,
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );

      setLoading(false);
    }
  };

  const submitSharkPePayment = async (e) => {
    e.preventDefault();
    if (Number(withdrawAmount) < 11) {
      toast.error(
        <div>
          <ErrorIcon /> {langData?.['withdrawal_amount_cannot_be_less_than_11']}
        </div>,
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      return false;
    }
    setLoading(true);
    try {
      const payload = {
        amount: withdrawAmount,
        notes: withdrawNotes,
        payment_method_id: selectedAccountId,
      };
      const response = await FEATURE_API.post(
        `/agpay/v2/sharkpe/transactions/:withdraw`,
        payload,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        }
      );
      if (response.status === 204) {
        toast.success(
          <div>
            <SuccessIcon /> {langData?.['txn_saved_success_txt']}
          </div>,
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
        setOpenWithdrawModal(false);
        history.push('/my_transactions');
      } else {
        toast.error(
          <div>
            <ErrorIcon /> {langData?.['general_err_txt']}
          </div>,
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
      }
      setLoading(false);
    } catch (error) {
      toast.error(
        <div>
          <ErrorIcon /> {error?.response?.data}
        </div>,
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );

      setLoading(false);
    }
  };

  const submitTrustPayPayment = async (e) => {
    e.preventDefault();
    if (Number(withdrawAmount) < 10) {
      toast.error(
        <div>
          <ErrorIcon /> {langData?.['withdrawal_amount_cannot_be_less_than_10']}
        </div>,
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      return false;
    }
    setLoading(true);
    try {
      const payload = {
        amount: withdrawAmount,
        notes: withdrawNotes,
        payment_method_id: selectedAccountId,
      };
      const response = await FEATURE_API.post(
        `/agpay/v2/trustlypay/transactions/:withdraw`,
        payload,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        }
      );
      if (response.status === 204) {
        toast.success(
          <div>
            <SuccessIcon /> {langData?.['txn_saved_success_txt']}
          </div>,
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
        setOpenWithdrawModal(false);
        history.push('/my_transactions');
      } else {
        toast.error(
          <div>
            <ErrorIcon /> {langData?.['general_err_txt']}
          </div>,
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
      }
      setLoading(false);
    } catch (error) {
      toast.error(
        <div>
          <ErrorIcon /> {error?.response?.data}
        </div>,
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );

      setLoading(false);
    }
  };

  useEffect(() => {
    if (paymentOption) {
      fetchPaymentMethod();
      setAccountDetails([]);
      setSelectedAccountId('');
      setWithdrawAmount('');
      setWithdrawNotes('');
      setAccountNumber('');
      setWithdrawAmount('');
      setHolderName('');
      setDisplayName('');
      setIfscCode('');
      setAddAccount(false);
    }
  }, [paymentOption, providersList]);

  useEffect(() => {
    if (addAccount) {
      setSelectedAccountId('');
    }
  }, [addAccount]);

  useEffect(() => {
    if (selectedAccountId) {
      setAddAccount(false);
    }
  }, [selectedAccountId]);

  const submitDetails = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = {
        accountHolderName: holderName,
        accountNumber: accountNumber,
        displayName: '',
        bankName: bankName,
        branchName: branchName,
        ifscCode: ifscCode,
        paymentMethod:
          paymentOption === 'NEFT' ? 'BANK_TRANSFER' : 'UPI_TRANSFER',
      };

      const payTMPayload = {
        accountNumber: accountNumber,
        accountHolderName: holderName,
        displayName: displayName,
        paymentMethod: 'PAYTM_WALLET_TRANSFER',
      };
      const response = await FEATURE_API.post(
        `/agpay/v2/pgman/payment-methods`,
        paymentOption === 'PAYTM_WALLET' ? payTMPayload : payload,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        }
      );
      if (response.status === 200 || 204) {
        toast.success(
          <div>
            <SuccessIcon /> {langData?.['details_saved_success_txt']}
          </div>,
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
        history.push('/my_transactions');
        setOpenWithdrawModal(false);
      } else {
        toast.error(
          <div>
            <ErrorIcon /> {langData?.['general_err_txt']}
          </div>,
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
      }
      setLoading(false);
    } catch (error) {
      toast.error(
        <div>
          <ErrorIcon /> {error?.response?.data?.message}
        </div>,
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );

      setLoading(false);
    }
  };

  const submitTrustpayDetails = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = {
        accountHolderName: holderName,
        accountNumber: accountNumber,
        displayName: '',
        bankName: bankName,
        branchName: branchName,
        ifscCode: ifscCode,
        paymentMethod: 'TRUSTPAY_TRANSFER',
        upiId: upiId?.toLowerCase(),
      };

      const response = await FEATURE_API.post(
        `/agpay/v2/trustlypay/payment-methods`,
        payload,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        }
      );
      if (response.status === 200 || 204) {
        toast.success(
          <div>
            <SuccessIcon /> {'Deatils Saved Successfully!'}
          </div>,
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
        history.push('/my_transactions');
        setOpenWithdrawModal(false);
      } else {
        toast.error(
          <div>
            <ErrorIcon /> {langData?.['general_err_txt']}
          </div>,
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
      }
      setLoading(false);
    } catch (error) {
      toast.error(
        <div>
          <ErrorIcon /> {error?.response?.data?.message}
        </div>,
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      setLoading(false);
    }
  };

  const deletePaymentMethod = async () => {
    try {
      let provider = 'pgman';
      if (providersList[0] === 'TRUSTLYPAY') {
        provider = 'trustlypay';
      }
      const response = await AGPAY_API.delete(
        `/agpay/v2/${provider}/payment-methods/${deleteId}`,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        }
      );

      if (response.status === 204 || 200) {
        fetchPaymentMethod();
        toast.success(
          <div>
            <SuccessIcon /> {langData?.['beneficiary_account_deleted_success_txt']}
          </div>
        );
      }
      // setDeleteId(null);
    } catch (err) {
      toast.error(err.response.data.message);
      // setDeleteId(null);
    }
  };

  const submitAbcPayment = async (e) => {
    e.preventDefault();
    if (Number(withdrawAmount) < 100) {
      toast.error(
        <div>
          <ErrorIcon /> {langData?.['min_100_withdrawal_amount_txt']}
        </div>,
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      return false;
    }
    setLoading(true);
    try {
      const payload = {
        amount: withdrawAmount,
        notes: withdrawNotes,
        payment_method_id: selectedAccountId,
        payment_method: 'BANK_TRANSFER',
        currency_type: 'INR',
        mobile_number: '9000900099',
      };
      const response = await FEATURE_API.post(
        `/agpay/v2/zenpay/transactions/:withdraw`,
        payload,
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
        }
      );
      if (response.status === 200) {
        toast.success(
          <div>
            <SuccessIcon /> {langData?.['txn_saved_success_txt']}
          </div>,
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
        setOpenWithdrawModal(false);
        history.push('/my_transactions');
      } else {
        toast.error(
          <div>
            <ErrorIcon /> {'Something went wrong'}
          </div>,
          {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
      }
      setLoading(false);
    } catch (error) {
      toast.error(
        <div>
          <ErrorIcon /> {error?.response?.data?.message}
        </div>,
        {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );

      setLoading(false);
    }
  };

  return (
    <div className="reports-ctn payment-withdraw-ctn">
      {loading ? <Spinner /> : null}
      {/* {
        providersList?.length === 0 ? (
          <Redirect to="/home" />
        ) : null
      } */}
      <div className="header-ctn my-payment-option">
        <IonRow>
          <div className="img-page-title-row mob-view">
            <img className="title-image" src={withdrawal} />
            <div className="title">{langData?.['withdraw']}</div>
          </div>
          <div className="mob-view">
            <Button
              onClick={(e) => {
                history.push('/transaction/deposit');
              }}
              className="withdraw-deposit-btn actions-btn mob-view"
            >
              {langData?.['deposit']}
            </Button>
          </div>
        </IonRow>
        <div className="deposit-form-ctn">
          {providersList?.length > 1 && (
            <Tabs
              value={tabValue}
              onChange={(_, newValue) => {
                setTabValue(newValue);
                if(newValue == 4) {
                  if(paymentOption != 'CRYPTO_WALLET_TRANSFER'){
                    setPaymentOption('CRYPTO_WALLET_TRANSFER');
                  } else {
                    fetchPaymentMethod();
                  }
                } else {
                  setAccountDetails([]);
                }
              }}
            >
              {providersList?.includes('ZENPAY') && (
                <Tab value={0} label="Option 1" />
              )}
              {providersList?.includes('PGMAN') && (
                <Tab value={1} label="Option 2" />
              )}
              {providersList?.includes('SHARKPE') && (
                <Tab value={2} label="Option 3" />
              )}
              {providersList?.includes('TRUSTLYPAY') && (
                <Tab value={3} label="Option 4" />
              )}
              {providersList?.includes('ZENPAYCRYPTO') && (
                <Tab value={4} label="Crypto" />
              )}
            </Tabs>
          )}

          {providersList.includes('ZENPAY') && (
            <TabPanel value={tabValue} index={0}>
              <div className="payment-option-title">{langData?.['choose_payment_option']}</div>
              <Button
                className={
                  paymentOption === 'NEFT'
                    ? 'active payment-btn'
                    : 'payment-btn'
                }
                onClick={() => setPaymentOption('NEFT')}
              >
                <img
                  className={'payment-icon'}
                  alt="bank"
                  src={bank}
                  loading="lazy"
                />
              </Button>
              <div className="account-details-ctn">
                <Tabs
                  value={1}
                  variant="scrollable"
                  scrollButtons="off"
                  className="actions-list"
                >
                  <>
                    {accountDetails?.map((acc) => (
                      <>
                        <>
                          <div className="account-btn-ctn">
                            <Button
                              className={
                                acc?.id?.toString() === selectedAccountId
                                  ? 'active account-detail-withdraw'
                                  : 'account-detail-withdraw'
                              }
                              onClick={() =>
                                setSelectedAccountId(acc?.id?.toString())
                              }
                            >
                              <div className="account-name">
                                {acc?.paymentMethodDetails?.accountHolderName}
                              </div>
                              <div className="account-number">
                                {acc?.paymentMethodDetails?.accountNumber}
                              </div>
                              <div className="account-number">
                                {acc?.paymentMethodDetails?.upiId}
                              </div>
                              <div className="account-number">
                                {acc?.paymentMethodDetails?.phoneNumber}
                              </div>
                              <div className="account-number">
                                {acc?.paymentMethodDetails?.bankName}
                                {acc?.paymentMethodDetails?.bankName
                                  ? ','
                                  : null}{' '}
                                {acc?.paymentMethodDetails?.branchName}
                              </div>
                              {paymentOption === 'NEFT' && (
                                <div className="account-ifsc">
                                  IFSC: {acc?.paymentMethodDetails?.ifscCode}
                                </div>
                              )}
                            </Button>
                            <div className="delete-btn-ctn">
                              <Button
                                className="method-delete-btn"
                                onClick={() => {
                                  setShowDeleteModal(true);
                                  setDeleteId(acc?.id);
                                }}
                              >
                                <DeleteForeverOutlined />
                              </Button>
                            </div>
                          </div>
                        </>
                      </>
                    ))}
                  </>
                </Tabs>
                {/* {accountDetails?.length > 0 ? (
            <> */}
                {paymentOption ? (
                  <Button
                    title="Add Account"
                    onClick={() => {
                      setAddAccount(true);
                    }}
                    className="add-btn "
                  >
                    <div className="add-account ">
                      <Add />{' '}
                    </div>
                  </Button>
                ) : null}

                {/* </> */}
                {/* ) : null} */}
              </div>
              {paymentOption === 'NEFT' && addAccount && (
                <form
                  className="account-inputs"
                  onSubmit={(e) => submitDetails(e)}
                >
                  <div className="payment-option-title">{langData?.['enter_details']}</div>
                  <div className="account-input">
                    <div className="account-label">{langData?.['account_no']}</div>
                    <NumberFormat
                      required
                      className="acc-input"
                      placeholder={langData?.['enter_account_no']}
                      value={accountNumber}
                      onChange={(e) => setAccountNumber(e.target.value)}
                      decimalSeparator={false}
                    />
                  </div>
                  <div className="account-input">
                    <div className="account-label">{langData?.['account_holder_name']}</div>
                    <TextField
                      required
                      placeholder={langData?.['account_holder_name']}
                      className="acc-input"
                      value={holderName}
                      onChange={(e) => setHolderName(e.target.value)}
                    />
                  </div>
                  <div className="account-input">
                    <div className="account-label">{langData?.['bank_name']}</div>

                    <TextField
                      required
                      placeholder={langData?.['bank_name']}
                      className="acc-input"
                      value={bankName}
                      onChange={(e) => setBankName(e.target.value)}
                    />
                  </div>
                  <div className="account-input">
                    <div className="account-label">{langData?.['branch_name']}</div>

                    <TextField
                      required
                      placeholder={langData?.['branch_name']}
                      className="acc-input"
                      value={branchName}
                      onChange={(e) => setBranchName(e.target.value)}
                    />
                  </div>
                  <div className="account-input">
                    <div className="account-label">{langData?.['ifsc_no']}</div>

                    <TextField
                      required
                      placeholder={langData?.['ifsc_code']}
                      className="acc-input"
                      value={ifscCode}
                      onChange={(e) => setIfscCode(e.target.value)}
                    />
                  </div>

                  <Button
                    className="submit-payment-btn"
                    type="submit"
                    endIcon={loading ? <IonSpinner name="lines-small" /> : ''}
                    disabled={loading ? true : false}
                  >
                    {langData?.['add']}
                  </Button>
                </form>
              )}

              {/* {
              selectedAccountId ? (
                <>
                  <div className="payment-options online-payment-options">
                    <Button
                      className={
                        onlinePaymentOption === 'IMPS' ? 'active payment-btn' : 'payment-btn'
                      }
                      onClick={() => setOnlinePaymentOption('IMPS')}
                    >
                      IMPS
                    </Button>
                    <Button
                      className={
                        onlinePaymentOption === 'NEFT' ? 'active payment-btn' : 'payment-btn'
                      }
                      onClick={() => setOnlinePaymentOption('NEFT')}
                    >
                      NEFT
                    </Button>
                  </div>
                </>
              ) : null
            } */}
              {selectedAccountId ? (
                <>
                  {/* <div className="withdraw-form-divider"></div> */}

                  <form
                    className="account-inputs"
                    onSubmit={(e) => {
                      if (tabValue === 0) {
                        submitAbcPayment(e);
                      }
                    }}
                  >
                    <div className="payment-option-title">
                    {langData?.['enter_payment_details']}
                    </div>
                    <div className="account-input">
                      <div className="account-label">{langData?.['enter_amount']}</div>
                      <NumberFormat
                        required
                        className="acc-input"
                        placeholder={langData?.['enter_withdraw_amount']}
                        value={withdrawAmount}
                        decimalSeparator={false}
                        onChange={(e) => setWithdrawAmount(e.target.value)}
                      />
                    </div>
                    <div className="account-input">
                      <div className="account-label">{langData?.['enter_notes']}</div>
                      <TextField
                        required
                        placeholder={langData?.['enter_notes']}
                        className="acc-input"
                        value={withdrawNotes}
                        onChange={(e) => setWithdrawNotes(e.target.value)}
                      />
                    </div>

                    <Button
                      className="submit-payment-btn"
                      type="submit"
                      disabled={loading ? true : false}
                      endIcon={loading ? <IonSpinner name="lines-small" /> : ''}
                    >
                      {langData?.['submit']}
                    </Button>
                  </form>
                </>
              ) : null}
            </TabPanel>
          )}

          {providersList.includes('PGMAN') && (
            <TabPanel value={tabValue} index={1} className="payment-options">
              <div className="payment-option-title">{langData?.['choose_payment_option']}</div>
              <Button
                className={
                  paymentOption === 'NEFT'
                    ? 'active payment-btn'
                    : 'payment-btn'
                }
                onClick={() => {
                  setPaymentOption('NEFT');
                  setUpiOption('');
                }}
              >
                <img
                  className={'payment-icon'}
                  alt="bank"
                  src={bank}
                  loading="lazy"
                />
              </Button>
              <Button
                className={
                  UpiOption === 'UPI' ? 'active payment-btn' : 'payment-btn'
                }
                onClick={() => {
                  setUpiOption('UPI');
                  setPaymentOption('GPAY');
                }}
              >
                <img
                  className={'payment-icon'}
                  alt="bank"
                  src={upiImg}
                  loading="lazy"
                />
              </Button>
              <div>
                {UpiOption ? (
                  <>
                    <Button
                      className={
                        paymentOption === 'GPAY'
                          ? 'active payment-btn'
                          : 'payment-btn'
                      }
                      onClick={() => setPaymentOption('GPAY')}
                    >
                      <img
                        className={'payment-icon'}
                        alt="gpay"
                        src={gpay}
                        loading="lazy"
                      />
                    </Button>
                    <Button
                      className={
                        paymentOption === 'PHONEPE'
                          ? 'active payment-btn'
                          : 'payment-btn'
                      }
                      onClick={() => setPaymentOption('PHONEPE')}
                    >
                      <img
                        className={'payment-icon'}
                        alt="phonepay"
                        src={phonepay}
                        loading="lazy"
                      />
                    </Button>
                    <Button
                      className={
                        paymentOption === 'PAYTM_WALLET'
                          ? 'active payment-btn'
                          : 'payment-btn'
                      }
                      onClick={() => setPaymentOption('PAYTM_WALLET')}
                    >
                      <img
                        className={'payment-icon'}
                        alt="paytm"
                        src={paytm}
                        loading="lazy"
                        height={30}
                      />
                    </Button>
                  </>
                ) : null}
                {accountDetails?.length > 0 ? (
                  <>
                    <div className="payment-form-divider"></div>

                    <div className="payment-option-title">
                    {langData?.['choose_beneficiary_account']}
                    </div>
                  </>
                ) : null}
                <div className="account-details-ctn">
                  <Tabs
                    value={1}
                    variant="scrollable"
                    scrollButtons="off"
                    className="actions-list"
                  >
                    <>
                      {accountDetails?.map((acc) => (
                        <>
                          <>
                            <div className="account-btn-ctn">
                              <Button
                                className={
                                  acc?.id?.toString() === selectedAccountId
                                    ? 'active account-detail-withdraw'
                                    : 'account-detail-withdraw'
                                }
                                onClick={() =>
                                  setSelectedAccountId(acc?.id?.toString())
                                }
                              >
                                <div className="account-name">
                                  {acc?.paymentMethodDetails?.accountHolderName}
                                </div>
                                <div className="account-number">
                                  {acc?.paymentMethodDetails?.accountNumber}
                                </div>
                                <div className="account-number">
                                  {acc?.paymentMethodDetails?.upiId}
                                </div>
                                <div className="account-number">
                                  {acc?.paymentMethodDetails?.phoneNumber}
                                </div>
                                <div className="account-number">
                                  {acc?.paymentMethodDetails?.bankName}
                                  {acc?.paymentMethodDetails?.bankName
                                    ? ','
                                    : null}{' '}
                                  {acc?.paymentMethodDetails?.branchName}
                                </div>
                                {paymentOption === 'NEFT' && (
                                  <div className="account-ifsc">
                                    IFSC: {acc?.paymentMethodDetails?.ifscCode}
                                  </div>
                                )}
                              </Button>
                              <div className="delete-btn-ctn">
                                <Button
                                  className="method-delete-btn"
                                  onClick={() => {
                                    setShowDeleteModal(true);
                                    setDeleteId(acc?.id);
                                  }}
                                >
                                  <DeleteForeverOutlined />
                                </Button>
                              </div>
                            </div>
                          </>
                        </>
                      ))}
                    </>
                  </Tabs>
                  {/* {accountDetails?.length > 0 ? (
            <> */}

                  {paymentOption ? (
                    <Button
                      title={langData?.['add_account']}
                      onClick={() => {
                        setAddAccount(true);
                      }}
                      className="add-btn "
                    >
                      <div className="add-account ">
                        <Add />{' '}
                      </div>
                    </Button>
                  ) : null}

                  {/* </> */}
                  {/* ) : null} */}
                </div>
              </div>
              {selectedAccountId ? (
                <>
                  <div className="withdraw-form-divider"></div>

                  <form
                    className="account-inputs"
                    onSubmit={(e) => {
                      if (tabValue === 0) {
                        submitZenPayment(e);
                      } else if (tabValue === 1) {
                        submitPayment(e);
                      } else {
                        submitSharkPePayment(e);
                      }
                    }}
                  >
                    <div className="payment-option-title">
                    {langData?.['enter_payment_details']}
                    </div>
                    <div className="account-input">
                      <div className="account-label">{langData?.['enter_amount']}</div>
                      <NumberFormat
                        required
                        className="acc-input"
                        placeholder={langData?.['enter_withdraw_amount']}
                        value={withdrawAmount}
                        decimalSeparator={false}
                        onChange={(e) => setWithdrawAmount(e.target.value)}
                      />
                    </div>
                    <div className="account-input">
                      <div className="account-label">{langData?.['enter_notes']}</div>
                      <TextField
                        required
                        placeholder={langData?.['enter_notes']}
                        className="acc-input"
                        value={withdrawNotes}
                        onChange={(e) => setWithdrawNotes(e.target.value)}
                      />
                    </div>

                    <Button
                      className="submit-payment-btn"
                      type="submit"
                      disabled={loading ? true : false}
                      endIcon={loading ? <IonSpinner name="lines-small" /> : ''}
                    >
                      {langData?.['submit']}
                    </Button>
                  </form>
                </>
              ) : null}

              {paymentOption === 'NEFT' && addAccount && (
                <form
                  className="account-inputs"
                  onSubmit={(e) => submitDetails(e)}
                >
                  <div className="payment-option-title">{langData?.['enter_details']}</div>
                  <div className="account-input">
                    <div className="account-label">{langData?.['account_no']}</div>
                    <NumberFormat
                      required
                      className="acc-input"
                      placeholder={langData?.['enter_account_no']}
                      value={accountNumber}
                      onChange={(e) => setAccountNumber(e.target.value)}
                      decimalSeparator={false}
                    />
                  </div>
                  <div className="account-input">
                    <div className="account-label">{langData?.['account_holder_name']}</div>
                    <TextField
                      required
                      placeholder={langData?.['account_holder_name']}
                      className="acc-input"
                      value={holderName}
                      onChange={(e) => setHolderName(e.target.value)}
                    />
                  </div>
                  <div className="account-input">
                    <div className="account-label">{langData?.['bank_name']}</div>

                    <TextField
                      required
                      placeholder={langData?.['bank_name']}
                      className="acc-input"
                      value={bankName}
                      onChange={(e) => setBankName(e.target.value)}
                    />
                  </div>
                  <div className="account-input">
                    <div className="account-label">{langData?.['branch_name']}</div>

                    <TextField
                      required
                      placeholder={langData?.['branch_name']}
                      className="acc-input"
                      value={branchName}
                      onChange={(e) => setBranchName(e.target.value)}
                    />
                  </div>
                  <div className="account-input">
                    <div className="account-label">{langData?.['ifsc_no']}</div>

                    <TextField
                      required
                      placeholder={langData?.['ifsc_code']}
                      className="acc-input"
                      value={ifscCode}
                      onChange={(e) => setIfscCode(e.target.value)}
                    />
                  </div>

                  <Button
                    className="submit-payment-btn"
                    type="submit"
                    endIcon={loading ? <IonSpinner name="lines-small" /> : ''}
                    disabled={loading ? true : false}
                  >
                    {langData?.['add']}
                  </Button>
                </form>
              )}
              {paymentOption === 'PAYTM_WALLET' && addAccount && (
                <form
                  className="account-inputs"
                  onSubmit={(e) => submitDetails(e)}
                >
                  <div className="payment-option-title">{langData?.['enter_details']}</div>
                  <div className="account-input">
                    <div className="account-label">{langData?.['phone_number']}</div>
                    <NumberFormat
                      required
                      className="acc-input"
                      placeholder={langData?.['enter_phone_number_txt']}
                      value={accountNumber}
                      onChange={(e) => setAccountNumber(e.target.value)}
                      decimalSeparator={false}
                    />
                  </div>
                  <div className="account-input">
                    <div className="account-label">{langData?.['account_holder_name']}</div>
                    <TextField
                      required
                      placeholder={langData?.['account_holder_name']}
                      className="acc-input"
                      value={holderName}
                      onChange={(e) => setHolderName(e.target.value)}
                    />
                  </div>
                  <div className="account-input">
                    <div className="account-label">{langData?.['display_name']}</div>

                    <TextField
                      required
                      placeholder={langData?.['display_name']}
                      className="acc-input"
                      value={displayName}
                      onChange={(e) => setDisplayName(e.target.value)}
                    />
                  </div>

                  <Button
                    className="submit-payment-btn"
                    type="submit"
                    endIcon={loading ? <IonSpinner name="lines-small" /> : ''}
                    disabled={loading ? true : false}
                  >
                    {langData?.['add']}
                  </Button>
                </form>
              )}

              {(paymentOption === 'GPAY' || paymentOption === 'PHONEPE') &&
                addAccount && (
                  <>
                    <div className="withdraw-form-divider"></div>
                    <form
                      className="account-inputs"
                      onSubmit={(e) => submitDetails(e)}
                    >
                      <div className="payment-option-title">
                      {langData?.['enter_upi_details']}
                      </div>
                      <div className="account-input">
                        <div className="account-label">{langData?.['enter_upi_id']}</div>

                        <TextField
                          required
                          className="acc-input"
                          placeholder={langData?.['upi_id']}
                          value={accountNumber}
                          onChange={(e) => setAccountNumber(e.target.value)}
                        />
                      </div>
                      <div className="account-input">
                        <div className="account-label">{langData?.['account_holder_name']}</div>

                        <TextField
                          required
                          placeholder={langData?.['account_holder_name']}
                          className="acc-input"
                          value={holderName}
                          onChange={(e) => setHolderName(e.target.value)}
                        />
                      </div>
                      <div className="account-input">
                        <div className="account-label">{langData?.['display_name']}</div>

                        <TextField
                          required
                          placeholder={langData?.['display_name']}
                          className="acc-input"
                          value={displayName}
                          onChange={(e) => setDisplayName(e.target.value)}
                        />
                      </div>

                      <Button
                        className="submit-payment-btn"
                        type="submit"
                        endIcon={
                          loading ? <IonSpinner name="lines-small" /> : ''
                        }
                        disabled={loading ? true : false}
                      >
                        {langData?.['add']}
                      </Button>
                    </form>
                  </>
                )}
            </TabPanel>
          )}

          {providersList.includes('SHARKPE') && (
            <TabPanel value={tabValue} index={2} className="payment-options">
              <div className="payment-option-title">{langData?.['choose_payment_option']}</div>
              <Button
                className={
                  paymentOption === 'NEFT'
                    ? 'active payment-btn'
                    : 'payment-btn'
                }
                onClick={() => {
                  setPaymentOption('NEFT');
                  setUpiOption('');
                }}
              >
                <img
                  className={'payment-icon'}
                  alt="bank"
                  src={bank}
                  loading="lazy"
                />
              </Button>
              {/* TODO:: Jayanth uncomment when UPI is working */}
              {/* <Button
              className={
                UpiOption === 'UPI' ? 'active payment-btn' : 'payment-btn'
              }
              onClick={() => {setUpiOption('UPI');setPaymentOption('GPAY');}}
            >
              <img
                className={'payment-icon'}
                alt="bank"
                src={upiImg}
                loading="lazy"
              />
            </Button> */}
              <div>
                {accountDetails?.length > 0 ? (
                  <>
                    <div className="payment-form-divider"></div>

                    <div className="payment-option-title">
                    {langData?.['choose_beneficiary_account']}
                    </div>
                  </>
                ) : null}
                <div className="account-details-ctn">
                  <Tabs
                    value={1}
                    variant="scrollable"
                    scrollButtons="off"
                    className="actions-list"
                  >
                    <>
                      {accountDetails?.map((acc) => (
                        <>
                          <>
                            <div className="account-btn-ctn">
                              <Button
                                className={
                                  acc?.id?.toString() === selectedAccountId
                                    ? 'active account-detail-withdraw'
                                    : 'account-detail-withdraw'
                                }
                                onClick={() =>
                                  setSelectedAccountId(acc?.id?.toString())
                                }
                              >
                                <div className="account-name">
                                  {acc?.paymentMethodDetails?.accountHolderName}
                                </div>
                                <div className="account-number">
                                  {acc?.paymentMethodDetails?.accountNumber}
                                </div>
                                <div className="account-number">
                                  {acc?.paymentMethodDetails?.upiId}
                                </div>
                                <div className="account-number">
                                  {acc?.paymentMethodDetails?.phoneNumber}
                                </div>
                                <div className="account-number">
                                  {acc?.paymentMethodDetails?.bankName}
                                  {acc?.paymentMethodDetails?.bankName
                                    ? ','
                                    : null}{' '}
                                  {acc?.paymentMethodDetails?.branchName}
                                </div>
                                {paymentOption === 'NEFT' && (
                                  <div className="account-ifsc">
                                    {langData?.['ifsc']}: {acc?.paymentMethodDetails?.ifscCode}
                                  </div>
                                )}
                              </Button>
                              <div className="delete-btn-ctn">
                                <Button
                                  className="method-delete-btn"
                                  onClick={() => {
                                    setShowDeleteModal(true);
                                    setDeleteId(acc?.id);
                                  }}
                                >
                                  <DeleteForeverOutlined />
                                </Button>
                              </div>
                            </div>
                          </>
                        </>
                      ))}
                    </>
                  </Tabs>

                  {paymentOption ? (
                    <Button
                      title={langData?.['add_account']}
                      onClick={() => {
                        setAddAccount(true);
                      }}
                      className="add-btn "
                    >
                      <div className="add-account ">
                        <Add />{' '}
                      </div>
                    </Button>
                  ) : null}
                </div>
              </div>
              {selectedAccountId ? (
                <>
                  <div className="withdraw-form-divider"></div>

                  <form
                    className="account-inputs"
                    onSubmit={(e) => {
                      if (tabValue === 0) {
                        submitZenPayment(e);
                      } else if (tabValue === 1) {
                        submitPayment(e);
                      } else {
                        submitSharkPePayment(e);
                      }
                    }}
                  >
                    <div className="payment-option-title">
                    {langData?.['enter_payment_details']}
                    </div>
                    <div className="account-input">
                      <div className="account-label">{langData?.['enter_amount']}</div>
                      <NumberFormat
                        required
                        className="acc-input"
                        placeholder={langData?.['enter_withdraw_amount']}
                        value={withdrawAmount}
                        decimalSeparator={false}
                        onChange={(e) => setWithdrawAmount(e.target.value)}
                      />
                    </div>
                    <div className="account-input">
                      <div className="account-label">{langData?.['enter_notes']} </div>
                      <TextField
                        required
                        placeholder={langData?.['enter_notes']}
                        className="acc-input"
                        value={withdrawNotes}
                        onChange={(e) => setWithdrawNotes(e.target.value)}
                      />
                    </div>

                    <Button
                      className="submit-payment-btn"
                      type="submit"
                      disabled={loading ? true : false}
                      endIcon={loading ? <IonSpinner name="lines-small" /> : ''}
                    >
                      {langData?.['submit']}
                    </Button>
                  </form>
                </>
              ) : null}

              {paymentOption === 'NEFT' && addAccount && (
                <form
                  className="account-inputs"
                  onSubmit={(e) => submitDetails(e)}
                >
                  <div className="payment-option-title">{langData?.['enter_details']}</div>
                  <div className="account-input">
                    <div className="account-label">{langData?.['account_no']}</div>
                    <NumberFormat
                      required
                      className="acc-input"
                      placeholder={langData?.['enter_account_no']}
                      value={accountNumber}
                      onChange={(e) => setAccountNumber(e.target.value)}
                      decimalSeparator={false}
                    />
                  </div>
                  <div className="account-input">
                    <div className="account-label">{langData?.['account_holder_name']}</div>
                    <TextField
                      required
                      placeholder={langData?.['account_holder_name']}
                      className="acc-input"
                      value={holderName}
                      onChange={(e) => setHolderName(e.target.value)}
                    />
                  </div>
                  <div className="account-input">
                    <div className="account-label">{langData?.['branch_name']}</div>

                    <TextField
                      required
                      placeholder={langData?.['bank_name']}
                      className="acc-input"
                      value={bankName}
                      onChange={(e) => setBankName(e.target.value)}
                    />
                  </div>
                  <div className="account-input">
                    <div className="account-label">{langData?.['branch_name']}</div>

                    <TextField
                      required
                      placeholder={langData?.['branch_name']}
                      className="acc-input"
                      value={branchName}
                      onChange={(e) => setBranchName(e.target.value)}
                    />
                  </div>
                  <div className="account-input">
                    <div className="account-label">{langData?.['ifsc_no']}</div>

                    <TextField
                      required
                      placeholder={langData?.['ifsc_code']}
                      className="acc-input"
                      value={ifscCode}
                      onChange={(e) => setIfscCode(e.target.value)}
                    />
                  </div>

                  <Button
                    className="submit-payment-btn"
                    type="submit"
                    endIcon={loading ? <IonSpinner name="lines-small" /> : ''}
                    disabled={loading ? true : false}
                  >
                    {langData?.['add']}
                  </Button>
                </form>
              )}
              {paymentOption === 'PAYTM_WALLET' && addAccount && (
                <form
                  className="account-inputs"
                  onSubmit={(e) => submitDetails(e)}
                >
                  <div className="payment-option-title">{langData?.['enter_details']}s</div>
                  <div className="account-input">
                    <div className="account-label">{langData?.['phone_number']}</div>
                    <NumberFormat
                      required
                      className="acc-input"
                      placeholder={langData?.['enter_phone_number_txt']}
                      value={accountNumber}
                      onChange={(e) => setAccountNumber(e.target.value)}
                      decimalSeparator={false}
                    />
                  </div>
                  <div className="account-input">
                    <div className="account-label">{langData?.['account_holder_name']}</div>
                    <TextField
                      required
                      placeholder={langData?.['account_holder_name']}
                      className="acc-input"
                      value={holderName}
                      onChange={(e) => setHolderName(e.target.value)}
                    />
                  </div>
                  <div className="account-input">
                    <div className="account-label">{langData?.['display_name']}e</div>

                    <TextField
                      required
                      placeholder={langData?.['display_name']}
                      className="acc-input"
                      value={displayName}
                      onChange={(e) => setDisplayName(e.target.value)}
                    />
                  </div>

                  <Button
                    className="submit-payment-btn"
                    type="submit"
                    endIcon={loading ? <IonSpinner name="lines-small" /> : ''}
                    disabled={loading ? true : false}
                  >
                    {langData?.['add']}
                  </Button>
                </form>
              )}

              {(paymentOption === 'GPAY' || paymentOption === 'PHONEPE') &&
                addAccount && (
                  <>
                    <div className="withdraw-form-divider"></div>
                    <form
                      className="account-inputs"
                      onSubmit={(e) => submitDetails(e)}
                    >
                      <div className="payment-option-title">
                      {langData?.['enter_upi_details']}
                      </div>
                      <div className="account-input">
                        <div className="account-label">{langData?.['enter_upi_id']}</div>

                        <TextField
                          required
                          className="acc-input"
                          placeholder={langData?.['upi_id']}
                          value={accountNumber}
                          onChange={(e) => setAccountNumber(e.target.value)}
                        />
                      </div>
                      <div className="account-input">
                        <div className="account-label">{langData?.['account_holder_name']}</div>

                        <TextField
                          required
                          placeholder={langData?.['account_holder_name']}
                          className="acc-input"
                          value={holderName}
                          onChange={(e) => setHolderName(e.target.value)}
                        />
                      </div>
                      <div className="account-input">
                        <div className="account-label">{langData?.['display_name']}</div>

                        <TextField
                          required
                          placeholder={langData?.['display_name']}
                          className="acc-input"
                          value={displayName}
                          onChange={(e) => setDisplayName(e.target.value)}
                        />
                      </div>

                      <Button
                        className="submit-payment-btn"
                        type="submit"
                        endIcon={
                          loading ? <IonSpinner name="lines-small" /> : ''
                        }
                        disabled={loading ? true : false}
                      >
                        {langData?.['add']}
                      </Button>
                    </form>
                  </>
                )}
            </TabPanel>
          )}

          {providersList.includes('TRUSTLYPAY') && (
            <TabPanel value={tabValue} index={3} className="payment-options">
              <div className="payment-option-title">{langData?.['choose_payment_option']}</div>
              <Button
                className={
                  paymentOption === 'NEFT'
                    ? 'active payment-btn'
                    : 'payment-btn'
                }
                onClick={() => {
                  setPaymentOption('NEFT');
                  setUpiOption('');
                }}
              >
                <img
                  className={'payment-icon'}
                  alt="bank"
                  src={bank}
                  loading="lazy"
                />
              </Button>
              <Button
                className={
                  UpiOption === 'UPI' ? 'active payment-btn' : 'payment-btn'
                }
                onClick={() => {
                  setUpiOption('UPI');
                  setPaymentOption('GPAY');
                }}
              >
                <img
                  className={'payment-icon'}
                  alt="bank"
                  src={upiImg}
                  loading="lazy"
                />
              </Button>
              <div>
                {accountDetails?.length > 0 ? (
                  <>
                    <div className="payment-form-divider"></div>

                    <div className="payment-option-title">
                    {langData?.['choose_beneficiary_account']}
                    </div>
                  </>
                ) : null}
                <div className="account-details-ctn">
                  <Tabs
                    value={1}
                    variant="scrollable"
                    scrollButtons="off"
                    className="actions-list"
                  >
                    <>
                      {accountDetails?.map((acc) => (
                        <>
                          <>
                            <div className="account-btn-ctn">
                              <Button
                                className={
                                  acc?.id?.toString() === selectedAccountId
                                    ? 'active account-detail-withdraw'
                                    : 'account-detail-withdraw'
                                }
                                onClick={() =>
                                  setSelectedAccountId(acc?.id?.toString())
                                }
                              >
                                <div className="account-name">
                                  {acc?.paymentMethodDetails?.accountHolderName}
                                </div>
                                <div className="account-number">
                                  {acc?.paymentMethodDetails?.accountNumber}
                                </div>
                                <div className="account-number">
                                  {acc?.paymentMethodDetails?.upiId}
                                </div>
                                <div className="account-number">
                                  {acc?.paymentMethodDetails?.phoneNumber}
                                </div>
                                <div className="account-number">
                                  {acc?.paymentMethodDetails?.bankName}
                                  {acc?.paymentMethodDetails?.bankName
                                    ? ','
                                    : null}{' '}
                                  {acc?.paymentMethodDetails?.branchName}
                                </div>
                                {paymentOption === 'NEFT' && (
                                  <div className="account-ifsc">
                                    {langData?.['ifsc_code']}: {acc?.paymentMethodDetails?.ifscCode}
                                  </div>
                                )}
                              </Button>
                              <div className="delete-btn-ctn">
                                <Button
                                  className="method-delete-btn"
                                  onClick={() => {
                                    setShowDeleteModal(true);
                                    setDeleteId(acc?.id);
                                  }}
                                >
                                  <DeleteForeverOutlined />
                                </Button>
                              </div>
                            </div>
                          </>
                        </>
                      ))}
                    </>
                  </Tabs>

                  {paymentOption ? (
                    <Button
                      title="Add Account"
                      onClick={() => {
                        setAddAccount(true);
                      }}
                      className="add-btn "
                    >
                      <div className="add-account ">
                        <Add />{' '}
                      </div>
                    </Button>
                  ) : null}
                </div>
              </div>
              {selectedAccountId ? (
                <>
                  <div className="withdraw-form-divider"></div>

                  <form
                    className="account-inputs"
                    onSubmit={(e) => {
                      if (tabValue === 3) {
                        submitTrustPayPayment(e);
                      }
                    }}
                  >
                    <div className="payment-option-title">
                    {langData?.['enter_payment_details']}
                    </div>
                    <div className="account-input">
                      <div className="account-label">{langData?.['enter_amount']}</div>
                      <NumberFormat
                        required
                        className="acc-input"
                        placeholder={langData?.['enter_withdraw_amount']}
                        value={withdrawAmount}
                        decimalSeparator={false}
                        onChange={(e) => setWithdrawAmount(e.target.value)}
                      />
                    </div>
                    <div className="account-input">
                      <div className="account-label">{langData?.['enter_notes']}</div>
                      <TextField
                        required
                        placeholder={langData?.['enter_notes']}
                        className="acc-input"
                        value={withdrawNotes}
                        onChange={(e) => setWithdrawNotes(e.target.value)}
                      />
                    </div>

                    <Button
                      className="submit-payment-btn"
                      type="submit"
                      disabled={loading ? true : false}
                      endIcon={loading ? <IonSpinner name="lines-small" /> : ''}
                    >
                      {langData?.['submit']}
                    </Button>
                  </form>
                </>
              ) : null}

              {addAccount && (
                <form
                  className="account-inputs"
                  onSubmit={(e) => submitTrustpayDetails(e)}
                >
                  <div className="payment-option-title">{langData?.['enter_details']}</div>
                  <div className="account-input">
                    <div className="account-label">{langData?.['account_no']}</div>
                    <NumberFormat
                      required
                      className="acc-input"
                      placeholder={langData?.['enter_account_no']}
                      value={accountNumber}
                      onChange={(e) => setAccountNumber(e.target.value)}
                      decimalSeparator={false}
                    />
                  </div>
                  <div className="account-input">
                    <div className="account-label">{langData?.['account_holder_name']}</div>
                    <TextField
                      required
                      placeholder={langData?.['account_holder_name']}
                      className="acc-input"
                      value={holderName}
                      onChange={(e) => setHolderName(e.target.value)}
                    />
                  </div>
                  <div className="account-input">
                    <div className="account-label">{langData?.['bank_name']}</div>

                    <TextField
                      required
                      placeholder={langData?.['bank_name']}
                      className="acc-input"
                      value={bankName}
                      onChange={(e) => setBankName(e.target.value)}
                    />
                  </div>
                  <div className="account-input">
                    <div className="account-label">{langData?.['branch_name']}</div>

                    <TextField
                      required
                      placeholder={langData?.['branch_name']}
                      className="acc-input"
                      value={branchName}
                      onChange={(e) => setBranchName(e.target.value)}
                    />
                  </div>
                  <div className="account-input">
                    <div className="account-label">{langData?.['ifsc_no']}</div>

                    <TextField
                      required
                      placeholder={langData?.['ifsc_code']}
                      className="acc-input"
                      value={ifscCode}
                      onChange={(e) => setIfscCode(e.target.value)}
                    />
                  </div>
                  <div className="account-input">
                    <div className="account-label">{langData?.['upi_id']}</div>

                    <TextField
                      required
                      placeholder={langData?.['upi_id']}
                      className="acc-input"
                      value={upiId}
                      onChange={(e) => setUPIId(e.target.value)}
                    />
                  </div>

                  <Button
                    className="submit-payment-btn"
                    type="submit"
                    endIcon={loading ? <IonSpinner name="lines-small" /> : ''}
                    disabled={loading ? true : false}
                  >
                    {langData?.['add']}
                  </Button>
                </form>
              )}
            </TabPanel>
          )}

          {/* {providersList.includes('ZENPAYCRYPTO') && (
            <ZenpayCrypto
              tabValue={tabValue}
              index={4}
              paymentOption={paymentOption}
              accountDetails={accountDetails}
              setShowDeleteModal={setShowDeleteModal}
              setDeleteId={setDeleteId}
              setAddAccount={setAddAccount}
              withdrawAmount={withdrawAmount}
              setWithdrawAmount={setWithdrawAmount}
              loading={loading}
              setLoading={setLoading}
              setWithdrawNotes={setWithdrawNotes}
              addAccount={addAccount}
              setOpenWithdrawModal={setOpenWithdrawModal}
            >
            </ZenpayCrypto>
          )} */}
        </div>
      </div>

      <Dialog
        open={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        className="payment-method-confirm"
      >
        <div className="dialog-content">
          {/* <div className="void-bet-text">{getDisplayName(betText)}</div> */}
          <div className="payment-text-bold">{langData?.['account_will_be_deleted_text']}</div>
          <div>{langData?.['confirm_delete_txt']}</div>
        </div>
        <div className="dialog-footer">
          <Button
            color="primary"
            className="footer-action-btn"
            onClick={() => {
              deletePaymentMethod();
              setShowDeleteModal(false);
            }}
          >
            {langData?.['yes_confirm']}
          </Button>
          <Button
            color="primary"
            className="footer-action-btn"
            onClick={() => {
              setShowDeleteModal(false);
              setDeleteId(null);
            }}
          >
            {langData?.['cancel']}
          </Button>
        </div>
      </Dialog>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    langData:state.common.langData
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    setOpenWithdrawModal: (val) => dispatch(setOpenWithdrawModal(val)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Withdrawal);
